import { InjectionToken } from '@angular/core';
import { AppSettingsAdapter } from '../interfaces/app-settings-adapter.interface';

export const APP_SETTINGS_ADAPTER = new InjectionToken<AppSettingsAdapter<any>>(
	'APP_SETTINGS_ADAPTER'
);
